import { ClickEventHandler } from '../../../../../types/common'
import useTranslateMessage from '../../../../../hooks/useTranslateMessage'
import { ContainerForNoResults, MainText, SecondaryText, TextContainer, NestedContainer, ClearButton } from './styles'
import NextImage from 'next/image'

type NoResultsComponentProps = {
  withImage?: boolean
  onClick: ClickEventHandler
}
const NoResultsComponent = ({ onClick, withImage = false }: NoResultsComponentProps) => {
  const translate = useTranslateMessage()
  return (
    <ContainerForNoResults>
      {withImage && (
        <NextImage width={351} objectFit="cover" height={116} src="/hermes-static/images/NoResultsMobile.png" />
      )}
      <NestedContainer>
        <TextContainer>
          <MainText>{translate('global.no_results_found')}</MainText>
          <SecondaryText>{translate('global.no_results_found.secondary')}</SecondaryText>
        </TextContainer>
        <ClearButton onClick={onClick}>{translate('global.clean_search')}</ClearButton>
      </NestedContainer>
    </ContainerForNoResults>
  )
}

export default NoResultsComponent
